import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import react, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "redux/store/store";
import useProtectedRoute from "./hooks/useProtectedRoute";
import Navbar from "components/features/Navbar/Navbar";
import LoadingScreen from "components/shared/LoadingScreen";
import IdleTimerComponent from "routes/IdleTimer";
import t from "utils/i18n";

const ProtectedRoute = () => {
  const { isLoggingOut } = useSelector((state: RootState) => state.logout);
  const { isAuthenticated, isLoading, GatewayListRefetch } =
    useProtectedRoute();

  useEffect(() => {
    if (isAuthenticated) GatewayListRefetch();
  }, [isAuthenticated]);

  // Don't redirect if logout is in progress
  if (isLoggingOut) {
    return <LoadingScreen>{t("logout.loadingMessage")}</LoadingScreen>;
  }

  return (
    <>
      <AuthenticatedTemplate>
        {isLoading ? (
          <LoadingScreen>{t("suspense.loading")}</LoadingScreen>
        ) : (
          <div className="flex overflow-hidden">
            <Navbar />
            <IdleTimerComponent />
            {/* main outlet layout */}
            <main className="absolute pt-[96px] w-screen pl-14 h-full overflow-y-hidden">
              <Outlet />
            </main>
          </div>
        )}
      </AuthenticatedTemplate>
      <ReactQueryDevtools initialIsOpen={false} />
      <UnauthenticatedTemplate>
        {!isLoggingOut && <Navigate to="/login" replace />}
      </UnauthenticatedTemplate>
    </>
  );
};

export default react.memo(ProtectedRoute);
